module.exports = __webpack_public_path__ + "img/references_rvt2015.9fc081b9.png";